import style from './Footer.module.scss'

export const Footer = () => (
    <div className={style.container}>
        <span>@ Самарский государственный медицинский университет</span>
    </div>
)
